import { j as a } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as s } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const e = s(
  (o, r) => /* @__PURE__ */ a.jsx(
    t,
    {
      ref: r,
      ...o,
      image: (i) => /* @__PURE__ */ a.jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 16,
          height: 16,
          fill: "none",
          viewBox: "0 0 16 16",
          ...i,
          children: /* @__PURE__ */ a.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M4.5 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M4.5 8A1.75 1.75 0 1 1 1 8a1.75 1.75 0 0 1 3.5 0M2.75 15a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5M9.75 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M9.75 8a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M8 15a1.75 1.75 0 1 0 0-3.5A1.75 1.75 0 0 0 8 15M13.25 4.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5M13.25 9.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5M15 13.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"
            }
          )
        }
      )
    }
  )
);
e.displayName = "GridIcon";
export {
  e as GridIcon,
  e as default
};
//# sourceMappingURL=index.js.map
